import type { ListOption } from 'api/types';
import type { SelectChangeEvent } from '@mui/material';
import { SelectDropdown } from '@forethought-technologies/forethought-elements';

interface ListDropdownProps<ValueType extends string | string[]> {
  error: string;
  id: string;
  label: string;
  multiple?: boolean;
  onBlur?: () => void;
  onChange: (e: SelectChangeEvent<ValueType>) => void;
  options: ListOption[];
  placeholder: string;
  requiredLabel: string;
  showRequiredLabel?: boolean;
  value: ValueType;
}

const ListDropdown = <ValueType extends string | string[]>({
  error,
  id,
  label,
  multiple,
  onBlur,
  onChange,
  options,
  placeholder,
  requiredLabel,
  showRequiredLabel,
  value,
}: ListDropdownProps<ValueType>): JSX.Element => {
  return (
    <SelectDropdown
      error={error}
      id={id}
      isMenuSearchable={options.length > 10}
      label={label}
      menuMaxHeight={450}
      multiple={multiple}
      onBlur={onBlur}
      onChange={onChange}
      options={options}
      placeholder={placeholder}
      requiredLabel={requiredLabel}
      showRequiredLabel={showRequiredLabel}
      value={value}
      wrapItems={multiple} // Wrap items when `multiple === true`
    />
  );
};

export default ListDropdown;
